const Subtitle: FC = ({ children }) => (
  <p className="text-moon-14 text-trunks sm:text-moon-16">{children}</p>
);

export default Subtitle;
